export const Urls = {
  BACKEND_URL: "https://dg52vdbg4l5kncmjze77u2kuw40ekvqm.lambda-url.ap-south-1.on.aws",
  // BACKEND_URL: "https://besoman-backend.onrender.com",

  IMAGE_URL: "https://s3.tebi.io/abamoman/",
  // Add more URLs here
};
